<template>
  <el-dialog class="header_setting"
             :visible.sync="settingVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             :modal-append-to-body="false"
             append-to-body
             width="800px"
             title="个人设置">
    <el-form :model="infoForm"
             ref="infoForm"
             label-width="100px"
             class="formCont" @keydown.enter.native.prevent>
      <el-row>
        <el-col :span="12">
          <el-form-item label="真实姓名"
                        size="small"
                        :rules="[{ required: true, message: '请输入真实姓名' }]"
                        prop="name">
            <el-input clearable
                      placeholder="请输入真实姓名"
                      maxlength="100"
                      size="small"
                      v-model="infoForm.name">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="英文名称"
                        size="small">
            <el-input clearable
                      placeholder="请输入英文名称"
                      maxlength="100"
                      size="small"
                      v-model="infoForm.name_en">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系电话"
                        size="small"
                        :rules="[
                            { required: true, message: '请输入联系电话' }
                        ]"
                        prop="phone">
            <el-input clearable
                      placeholder="请输入联系电话"
                      maxlength="100"
                      size="small"
                      v-model.number="infoForm.phone">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别"
                        size="small"
                        style="text-align:left">
            <el-radio v-model="infoForm.sex"
                      :label="1">男</el-radio>
            <el-radio v-model="infoForm.sex"
                      :label="2">女</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="学历"
                        size="small">
            <el-select v-model="infoForm.education"
                       size="small"
                       placeholder="请选择学历"
                       clearable>
              <el-option v-for="item in educationList"
                         :key="item"
                         :label="item"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="籍贯"
                        size="small">
            <el-input clearable
                      placeholder="请输入籍贯"
                      maxlength="100"
                      size="small"
                      v-model="infoForm.hometown">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="电子邮箱"
                        size="small"
                        :rules="[
                            { required: true, message: '请输入电子邮箱' },
                            { type: 'email', message: '请输入正确的电子邮箱', trigger: ['blur', 'change'] }
                        ]"
                        prop="email">
            <el-input clearable
                      placeholder="请输入电子邮箱"
                      maxlength="100"
                      size="small"
                      v-model="infoForm.email">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出生日期"
                        size="small">
            <el-date-picker v-model="infoForm.birthday"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="紧急联系人"
                        size="small">
            <el-input clearable
                      placeholder="请输入紧急联系人"
                      maxlength="100"
                      size="small"
                      v-model="infoForm.urgent_person">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="紧急联系电话"
                        size="small">
            <el-input clearable
                      placeholder="请输入紧急联系电话"
                      maxlength="100"
                      size="small"
                      v-model="infoForm.urgent_phone">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="专业"
                        size="small">
            <el-input clearable
                      placeholder="请输入专业"
                      maxlength="100"
                      size="small"
                      v-model="infoForm.speciality">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="联系地址"
                        size="small">
            <el-input clearable
                      placeholder="请输入联系地址"
                      maxlength="100"
                      size="small"
                      v-model="infoForm.address">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 type="primary"
                 @click="save">保存</el-button>
      <el-button size="small"
                 type="danger"
                 @click="settingVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import * as api from "@/http/api.js";
export default {
    data() {
        return {
            infoForm: {},
        };
    },
    methods: {
        closeDialog() {
            this.infoForm = JSON.parse(JSON.stringify(this.userInfo));
            this.$refs["infoForm"].resetFields();
            this.$refs["infoForm"].clearValidate();
            this.$emit("update:settingVisible", false);
        },
        save() {
            this.$refs["infoForm"].validate((valid) => {
                if (valid) {
                    api.user(this.infoForm, "put", this.infoForm.id).then(
                        (res) => {
                            if (res) {
                                this.$message.success("保存成功");
                                this.$store.dispatch("getUserInfo");
                                this.closeDialog();
                            }
                        }
                    );
                }
            });
        },
    },
    props: {
        settingVisible: Boolean,
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.login.userInfo, // 用户信息
            educationList: (state) => state.index.education, // 学历列表
        }),
    },
    watch: {
        settingVisible: {
            handler(newValue) {
                if (newValue) {
                    this.infoForm = JSON.parse(JSON.stringify(this.userInfo));
                }
            },
            immediate: false,
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.header_setting {
    width: 100%;
    .formCont {
        width: 100%;
        .leftCont {
            width: 100%;
            // border-right: 1px solid #e8e8e8;
            .dialogTitle {
                display: flex;
                align-items: center;
                // justify-content: space-between;
                margin-top: 20px;
                .levelTagCont,
                .title {
                    // cursor: pointer;
                }
                .leftContainer {
                    display: flex;
                    align-items: center;
                }
            }

            .main {
                width: 100%;
                border-bottom: 1px #e8e8e8 solid;
                .mainTitle {
                    text-align: left;
                    color: #3582fb;
                    line-height: 2;
                    border-bottom: 1px #e8e8e8 solid;
                    margin-top: 20px;
                }
            }
        }
    }
    .ck-editor__editable {
        min-height: 100px;
    }
    .el-radio {
        margin-right: 20px;
    }
}
</style>
